module.exports = __webpack_public_path__ + "img/fi-water-side-rest-400x263.c4e14dca.jpg";